// components/Header.jsx

import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../styles/Header.module.css";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isReservation = location.pathname === '/reservation';
  const isCookies = location.pathname === '/cookie-policy';
  const isPrivacy = location.pathname === '/privacy-policy';
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
  };

const homeButton = () => {
  if(window.location.pathname == '/'){
    scrollToSection('home')
  } else{
    navigate('/');
  }
}

const wrapperFunction = (callback) => {
  setMobileMenu(false);
  callback();
};

  return (
    <header
      className={`${styles.header} ${
        scrolled ? styles.headerScrolled : ""}
        `}
    >
      <div className={styles.container}>
        
        {/* Logo */}
        <Link to="/" className={`${styles.logo} ${(isReservation || isCookies || isPrivacy) && !scrolled ? styles.reservation : ""}`}>
          Mesogeios
        </Link>

        {/* Desktop Navigation */}
        <nav className={`${styles.nav} ${(isReservation || isCookies || isPrivacy) && !scrolled ? styles.reservation : ""}`}>
            {/* Page Navigation */}
            <button onClick={() => homeButton()} className={styles.navButton}>
              Home
            </button>
            
            {/* Section Navigation (If these are on the home page) */}
            <button onClick={() => scrollToSection('menu')} className={styles.navButton}>
              Menu
            </button>
            <button onClick={() => scrollToSection('about')} className={styles.navButton}>
              About
            </button>
            <button onClick={() => scrollToSection('gallery')} className={styles.navButton}>
              Gallery
            </button>
            <button onClick={() => scrollToSection('contact')} className={styles.navButton}>
              Contact
            </button>
          </nav>

          <button 
            onClick={() => navigate('/reservation')} 
            className={styles.button}
          >
            Reserve Table
          </button>

        {/* Mobile Burger */}
        <button
          className={styles.burger}
          onClick={() => setMobileMenu(!mobileMenu)}
        >
          <span className={`${(isReservation || isCookies || isPrivacy) && !scrolled ? styles.reservationSpan : ""}`}></span>
          <span className={`${(isReservation || isCookies || isPrivacy) && !scrolled ? styles.reservationSpan : ""}`}></span>
          <span className={`${(isReservation || isCookies || isPrivacy) && !scrolled ? styles.reservationSpan : ""}`}></span>
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`${styles.mobileMenu} ${
          mobileMenu ? styles.mobileMenuActive : ""
        }`}
      >
        <button onClick={() => wrapperFunction(homeButton)} className={styles.mobileNavButton}>
          Home
        </button>

        <button onClick={() => wrapperFunction(() => scrollToSection('menu'))} className={styles.mobileNavButton}>
          Menu
        </button>

        <button onClick={() => wrapperFunction(() => scrollToSection('about'))} className={styles.mobileNavButton}>
          About
        </button>

        <button onClick={() => wrapperFunction(() => scrollToSection('gallery'))} className={styles.mobileNavButton}>
          Gallery
        </button>

        <button onClick={() => wrapperFunction(() => scrollToSection('contact'))} className={styles.mobileNavButton}>
          Contact
        </button>

        <button
          className={styles.mobileButton}
          onClick={() => wrapperFunction(() => navigate('/reservation'))}
        >
          Reserve Table
        </button>
      </div>
    </header>
  );
}